import React from 'react';
import { Typography } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BugReportIcon from '@mui/icons-material/BugReport';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

type WorkItemTitlePropsType = {
  workType: string | undefined
  id: number
}

export const WorkItemTitle = React.memo((props: WorkItemTitlePropsType) => {
  let component
  let taskId: number | string = props.id
  if(props.id === 1){
    taskId = ''
  } 

  switch (props.workType) {
    case 'Task':
      component = <Typography style={{color: 'darkgray'}}>
        <AssignmentTurnedInIcon fontSize="small" style={{ color: "rgb(242, 203, 29)",verticalAlign:"middle" }} />
        {' '} TASK {taskId}
       </Typography>
      break;
    case 'Bug':
      component = <Typography style={{color: 'darkgray'}}>
        <BugReportIcon  fontSize="small" style={{ color: 'rgb(204, 41, 61)', verticalAlign:"middle" }} />
         {' '} BUG {taskId}
      </Typography>
      break;
    case 'User Story':
      component = <Typography>
        <MenuBookIcon fontSize="small" style={{ color: 'rgb(0, 156, 204)', verticalAlign:"middle" }} />
        {' '} USER STORY {taskId}
      </Typography>
      break;
    case 'Feature':
      component = <Typography>
        <EmojiEventsIcon fontSize="small" style={{ color: "rgb(119, 59, 147)", verticalAlign:"middle" }} />
        {' '} FEATURE {taskId}
      </Typography>
      break;
    default:
      component = <Typography>
        <NewReleasesIcon fontSize="small" style={{ color: 'red', verticalAlign:"middle" }} />
        {' '} UNKNOWN {taskId}
      </Typography>
      break;
  }
  return (
    component
  );
})
